import { createFileRoute } from '@tanstack/react-router';
import { RuleAndPolicyPage } from './-components/RuleAndPolicyPage';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/rule-and-policy/')({
  component: RuleAndPolicyPage
});